// extracted by mini-css-extract-plugin
export default {"container":"techBuilder_container__wnEln","detail":"techBuilder_detail__Nv+WG","content":"techBuilder_content__+nH5g","footer":"techBuilder_footer__fq9oz"};